var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseIndicatorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5185",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#00D9AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseIndicatorActive);
export default __webpack_public_path__ + "static/media/ellipse_indicator_active.5778bfb73bf394d2c69ea850ca9b552c.svg";
export { ForwardRef as ReactComponent };